module.exports = __webpack_public_path__ + "img/36.24101a9e.png";